module.exports = __webpack_public_path__ + "html/upload.template.html";